import React from "react";
import Layout from "../layout/layout";
import Profiletabs from "./Profiletabs";
import { Link } from "react-router-dom";

const Bank = () => {
  return (
    <Layout>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-title">
              <div className="row align-items-center justify-content-between">
                <div className="col-xl-4">
                  <div className="page-title-content">
                    <h3>Bank</h3>
                    <p className="mb-2">Welcome Ekash Finance Management</p>
                  </div>
                </div>
                <div className="col-auto">
                  <div className="breadcrumbs">
                    <Link to="#">Home </Link>
                    <span>
                      <i className="fi fi-rr-angle-small-right" />
                    </span>
                    <Link to="#">Bank</Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xxl-12 col-xl-12">
            <Profiletabs />
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Bank Account or Card</h4>
              </div>
              <div className="card-body">
                <div className="verify-content">
                  <div className="d-flex align-items-center">
                    <span className="me-3 icon-circle bg-primary text-white">
                      <i className="fi fi-rs-bank" />
                    </span>
                    <div className="primary-number">
                      <h5 className="mb-0">Bank of America</h5>
                      <small>Bank **************5421</small>
                      <br />
                      <span className="text-success">Verified</span>
                    </div>
                  </div>
                  <button className=" btn btn-outline-primary">Manage</button>
                </div>
                <hr className="border opacity-1" />
                <div className="verify-content">
                  <div className="d-flex align-items-center">
                    <span className="me-3 icon-circle bg-primary text-white">
                      <i className="fi fi-rr-credit-card" />
                    </span>
                    <div className="primary-number">
                      <h5 className="mb-0">Master Card</h5>
                      <small>Credit Card *********5478</small>
                      <br />
                      <span className="text-success">Verified</span>
                    </div>
                  </div>
                  <button className=" btn btn-outline-primary">Manage</button>
                </div>
                <div className="mt-5">
                  <Link to="/add-bank" className="btn btn-primary m-2">
                    Add New Bank
                  </Link>
                  <Link to="/add-card" className="btn btn-primary m-2">
                    Add New Card
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Bank;
